import { Outlet } from 'react-router-dom'

import { CostCenterPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useCostCenterConfiguration } from 'modules/cost_centers/hooks/useCostCenterConfiguration'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const CostCentersPage = () => {
  const { company } = useCurrentSession()

  const { data, error, loading } = useQuery(CostCenterPageDocument, {
    errorPolicy: 'all',
    variables: { companyId: company.id },
  })

  const canManageCostCenters = data?.finance._policies.costCentersManageCostCenters.can ?? false
  const hasFeatureCostCenterManagement =
    data && (data.companies.featureAvailabilities[0]?.available ?? false)
  const hasNewStructureEnabled =
    data?.features?.featuresConnection?.nodes.find(
      (feature) => feature.name === 'dev_cost_center_new_structure'
    )?.enabled ?? false

  const {
    configurations,
    isLoading: isLoadingConfigurations,
    refetch: refetchConfigurations,
  } = useCostCenterConfiguration({
    skip: !hasNewStructureEnabled,
  })

  return (
    <ResponsivePage.Body
      error={error}
      variant="full"
      loading={loading || isLoadingConfigurations}
      showHeader={false}
      authorized={canManageCostCenters && hasFeatureCostCenterManagement}
    >
      <Outlet
        context={{
          hasFeatureCostCenterManagement,
          canManageCostCenters,
          hasNewStructureEnabled,
          configurations,
          refetchConfigurations,
        }}
      />
    </ResponsivePage.Body>
  )
}

export default CostCentersPage
